import { TextField } from '@mui/material'
import React from 'react'

type Props = {
	value: string
	placeholder: string
	onChange: (value: string) => void
}

export const NumberFilter: React.FC<Props> = ({ value, placeholder, onChange }) => (
	<TextField
		fullWidth
		variant="standard"
		size="small"
		type="number"
		value={value}
		placeholder={placeholder}
		onChange={(e) => onChange(e.target.value)}
		onKeyDown={(e) => e.stopPropagation()}
		onClick={(e) => e.stopPropagation()}
		sx={{
			'& .MuiInputBase-root': {
				height: '100%',
				py: '3px',
			},
		}}
	/>
)
